import axios, { AxiosResponse } from 'axios'

import {
  ShowCropWrite,
  ShowDetailedRead,
  ShowDetailedWrite,
  ShowId,
  ShowRead,
  ShowReportRead,
  ShowRichPageRead,
} from '@generated/types'

const BASE_URL = '/api/show'

export default {
  async fetchOne(id: ShowId): Promise<AxiosResponse<ShowDetailedRead>> {
    return axios.get(`${BASE_URL}/${id}/`)
  },

  async fetchRichPage(slug: string): Promise<AxiosResponse<ShowRichPageRead>> {
    return axios.get(`${BASE_URL}/rich-page/${encodeURIComponent(slug)}/`)
  },

  async fetchAll(searchQuery?: string): Promise<AxiosResponse<ShowRead[]>> {
    const config = searchQuery ? { params: { q: searchQuery } } : undefined
    return axios.get(`${BASE_URL}/`, config)
  },

  async create(data: ShowDetailedWrite): Promise<AxiosResponse<ShowDetailedRead>> {
    return axios.post(`${BASE_URL}/`, data)
  },

  async update(data: ShowDetailedWrite): Promise<AxiosResponse<ShowDetailedRead>> {
    if (data.id === undefined || data.id === null) {
      return Promise.reject(new Error('Show ID is required for update.'))
    }
    return axios.put(`${BASE_URL}/${data.id}/`, data)
  },

  async updateImage(id: ShowId, data: FormData): Promise<AxiosResponse<ShowDetailedRead>> {
    return axios.put(`${BASE_URL}/${id}/set_image/`, data)
  },

  async updateImagePosition(
    id: ShowId,
    data: {
      /* Define position data type if known */
    },
  ): Promise<AxiosResponse<ShowDetailedRead>> {
    return axios.put(`${BASE_URL}/${id}/set_image_position/`, data)
  },

  async updateCrops(id: ShowId, data: ShowCropWrite): Promise<AxiosResponse<ShowDetailedRead>> {
    return axios.put(`${BASE_URL}/${id}/set_crops/`, data)
  },

  async delete(id: ShowId): Promise<AxiosResponse> {
    return axios.delete(`${BASE_URL}/${id}/`)
  },

  async duplicate(id: ShowId): Promise<AxiosResponse<ShowDetailedRead>> {
    return axios.post(`${BASE_URL}/${id}/duplicate/`)
  },

  async fetchReport(queryParams?: {
    start_date?: string
    end_date?: string
  }): Promise<AxiosResponse<ShowReportRead[]>> {
    return axios.get(`${BASE_URL}/report/`, { params: queryParams })
  },
}
